import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme-switcher"
export default class extends Controller {
  static targets = ["lightButton", "systemButton", "darkButton"]

  connect() {
    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this.boundSystemThemeChange = this.handleSystemThemeChange.bind(this)
    this.mediaQuery.addEventListener("change", this.boundSystemThemeChange)

    this.applyCurrentTheme()
  }

  disconnect() {
    if (this.mediaQuery && this.boundSystemThemeChange) {
      this.mediaQuery.removeEventListener("change", this.boundSystemThemeChange)
    }
  }

  setTheme(event) {
    const theme = event.params.theme
    if (!["light", "system", "dark"].includes(theme)) return

    if (theme === "system") {
      localStorage.removeItem("theme")
      this.applyTheme(this.systemTheme())
      this.updateButtonStates("system")
      return
    }

    localStorage.setItem("theme", theme)
    this.applyTheme(theme)
    this.updateButtonStates(theme)
  }

  currentThemeMode() {
    const savedTheme = localStorage.getItem("theme")
    return ["light", "dark"].includes(savedTheme) ? savedTheme : "system"
  }

  applyCurrentTheme() {
    const currentThemeMode = this.currentThemeMode()

    if (currentThemeMode === "system") {
      this.applyTheme(this.systemTheme())
      this.updateButtonStates("system")
      return
    }

    this.applyTheme(currentThemeMode)
    this.updateButtonStates(currentThemeMode)
  }

  handleSystemThemeChange() {
    if (this.currentThemeMode() !== "system") return

    this.applyTheme(this.systemTheme())
    this.updateButtonStates("system")
  }

  systemTheme() {
    return this.mediaQuery.matches ? "dark" : "light"
  }

  applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme)
  }

  updateButtonStates(activeMode) {
    if (this.hasLightButtonTarget) {
      this.lightButtonTarget.classList.toggle("btn-active", activeMode === "light")
      this.lightButtonTarget.setAttribute("aria-pressed", (activeMode === "light").toString())
    }

    if (this.hasSystemButtonTarget) {
      this.systemButtonTarget.classList.toggle("btn-active", activeMode === "system")
      this.systemButtonTarget.setAttribute("aria-pressed", (activeMode === "system").toString())
    }

    if (this.hasDarkButtonTarget) {
      this.darkButtonTarget.classList.toggle("btn-active", activeMode === "dark")
      this.darkButtonTarget.setAttribute("aria-pressed", (activeMode === "dark").toString())
    }
  }
}
